export const DISCORD_COMMUNITY_HREF = "https://discord.gg/e4xYBHQX";
export const WHATSAPP_CHANNEL_HREF = "https://whatsapp.com/channel/0029VbCmjUV0wajnJtV2lW3T";
export const WHATSAPP_COMMUNITY_HREF = "https://chat.whatsapp.com/CeaQ6vvRsLSD4ML4ljfrJN";
export const PRIMARY_COMMUNITY_HREF = WHATSAPP_COMMUNITY_HREF;
